/**
 * @param {function} fn
 * @param {number|function} delay
 * @returns {(function(...[*]): void)|*}
 */
function debounceFunction(fn, delay = 300) {
  let prevTimer = null;
  return (...args) => {
    if (prevTimer) {
      clearTimeout(prevTimer);
    }
    prevTimer = window.setTimeout(
      () => {
        fn(...args);
        prevTimer = null;
      },
      typeof delay === "function" ? delay() : delay
    );
  };
}

export default {
  debounceFunction,
};
